import React from "react";
import "components/exception/ErrorPage.css";

const NoConnectionError = () => {
    const handleRetry = () => {
        window.location.reload();
    };

    return (
        <div style={{ textAlign: "center", marginTop: "50px" }}>
            <div className="error-container">
                <h1>🔌 No Internet Connection</h1>
                <p className="error-message">
                    Unable to connect to the server. Please check your internet
                    connection and try again.
                </p>
                <div className="error-details">
                    <p>Possible causes:</p>
                    <ul style={{ textAlign: "left", display: "inline-block" }}>
                        <li>You are not connected to the internet</li>
                        <li>The server is temporarily unavailable</li>
                        <li>
                            Your firewall or network settings may be blocking
                            the connection
                        </li>
                    </ul>
                </div>
            </div>
            <div style={{ marginTop: "30px" }}>
                <button
                    onClick={handleRetry}
                    style={{
                        padding: "10px 20px",
                        marginRight: "20px",
                        cursor: "pointer",
                        backgroundColor: "#007bff",
                        color: "white",
                        border: "none",
                        borderRadius: "4px",
                    }}
                >
                    Retry Connection
                </button>
                <a href="mailto:support@wishliz.com">Contact Support</a>
            </div>
        </div>
    );
};

export default NoConnectionError;
